<nb-card [accent]="status">
  
    <nb-card-body>
        <button class="close-button" nbButton size="small" (click)="close()">
            <nb-icon icon="close-outline"></nb-icon>
        </button>
        <div [ngClass]="['rounded-container', statusClass]">
            <nb-icon icon="checkmark-circle-outline" *ngIf="status === 'success'"></nb-icon>
            <nb-icon icon="alert-triangle-outline" *ngIf="status === 'warning'"></nb-icon>
            <nb-icon icon="close-outline" *ngIf="status === 'danger'"></nb-icon>
        </div>
        <div class="content">
            <h6>{{ title }}</h6>
            <p class="paragraph-2">{{ description }}</p>
            <button nbButton [status]="status" (click)="confirm()" class="confirm-button">{{ buttonText }}</button>
        </div>
    </nb-card-body>
</nb-card> 